import React, { Component } from "react";
import { withRouter } from "../common/with-router";
import { Row, Col, Breadcrumb, Card, Container, Alert } from "react-bootstrap";

class Sponsorship extends Component {
  render() {
    return (
      <div className="mt-4">
        <Breadcrumb className="p-2 rounded">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Patrocínio</Breadcrumb.Item>
        </Breadcrumb>

        <Container>
          {/* Header: Fusão do título novo com a descrição da versão anterior */}
          <div className="text-center my-5">
            <h2 className="font-weight-bold">Patrocínio com Impacto Digital Real</h2>
            <p className="lead text-muted mx-auto" style={{ maxWidth: '800px' }}>
              A Replay Pro transforma cada replay em um ativo de mídia digital. Sua marca no momento de maior emoção do esporte com métricas reais de engajamento.
            </p>
          </div>

          {/* NOVA SEÇÃO: Dados e Analytics (Mantida da versão nova para autoridade) */}
          <div className="bg-dark text-white p-5 rounded-lg shadow-lg mb-5" style={{ borderRadius: '25px' }}>
            <h4 className="text-center text-white-50 font-weight-bold mb-4">Por que investir na Replay Pro?</h4>
            <Row className="text-center">
              <Col md={3} className="mb-3">
                <h2 className="text-danger font-weight-bold">4x Mais</h2>
                <p className="small text-white-50">Retorno de marca em relação a campanhas tradicionais</p>
              </Col>
              <Col md={3} className="mb-3">
                <h2 className="text-danger font-weight-bold">100%</h2>
                <p className="small text-white-50">Orgânico. Os vídeos são compartilhados pelos próprios atletas</p>
              </Col>
              <Col md={3} className="mb-3">
                <h2 className="text-danger font-weight-bold">+60%</h2>
                <p className="small text-white-50">De aumento em pageviews quando vídeos e dados se unem</p>
              </Col>
              <Col md={3} className="mb-3">
                <h2 className="text-danger font-weight-bold">ROI</h2>
                <p className="small text-white-50">Métricas reais de visualização em cada inserção de marca</p>
              </Col>
            </Row>
          </div>

          {/* SEÇÃO MESCLADA: Benefícios Detalhados (Estrutura da versão antiga com ícones da nova) */}
          <Row className="mb-5">
            <Col md={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm bg-light">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-megaphone-fill text-danger fs-3 m-2"></i>
                    <h5 className="font-weight-bold text-danger mb-0">Benefícios para Patrocinadores</h5>
                  </div>
                  <ul className="text-dark ms-2">
                    <li className="mb-3"><strong>Exposição Orgânica:</strong> Sua marca aparece em vídeos esportivos de alta emoção (gols, pontos decisivos).</li>
                    <li className="mb-3"><strong>Métricas Reais:</strong> Acesso a dados de visualização e engajamento, sem "achismos".</li>
                    <li className="mb-3"><strong>Associação Positiva:</strong> Conexão direta com esporte, saúde, tecnologia e inovação.</li>
                    <li><strong>Alcance Qualificado:</strong> Atinja atletas e espectadores engajados diretamente no celular.</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm bg-light">
                <Card.Body>
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-shop-window text-danger fs-3 m-2"></i>
                    <h5 className="font-weight-bold text-danger mb-0">Para Quadras e Eventos</h5>
                  </div>
                  <ul className="text-dark ms-2">
                    <li className="mb-3"><strong>Nova Receita:</strong> Fonte de renda recorrente através da monetização do conteúdo digital.</li>
                    <li className="mb-3"><strong>Custo Zero:</strong> Possibilidade de custear a solução integralmente com a venda de cotas de patrocínio.</li>
                    <li className="mb-3"><strong>Valorização do Espaço:</strong> Diferencial tecnológico que atrai mais atletas e campeonatos.</li>
                    <li><strong>Experiência Premium:</strong> Ofereça o que os grandes estádios têm, na sua arena.</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* ALERT DA VERSÃO ANTIGA (Mantido pois resume bem a proposta) */}
          <Alert variant="danger" className="text-center py-4 mb-5 shadow-sm border-0">
            <h5 className="font-weight-bold"><i className="bi bi-cash-coin m-2"></i> Mais que replay: geração de valor</h5>
            <p className="mb-0">Além da experiência esportiva, permitimos a monetização do conteúdo por meio de patrocínios digitais integrados aos vídeos, criando uma nova fonte de receita.</p>
          </Alert>

          {/* PROVA SOCIAL (Logos da versão antiga com design melhorado) */}
          <div className="mb-5 p-4 rounded text-center border">
            <h5 className="font-weight-bold mb-4 text-muted text-uppercase small">Quem Já Confia na Replay Pro</h5>
            <div className="d-flex justify-content-center flex-wrap align-items-center grayscale-logos">
              <img src="/logos/35002/sponsors/35002-1.svg" alt="Sicoob" className="m-3 img-fluid" style={{ maxWidth: '130px', filter: 'grayscale(100%)', opacity: '0.7' }} />
              <img src="/logos/35001/sponsors/35001-6.svg" alt="Stone Net" className="m-3 img-fluid" style={{ maxWidth: '130px', filter: 'grayscale(100%)', opacity: '0.7' }} />
              <img src="/logos/35001/sponsors/35001-3.svg" alt="Supermercado Reis" className="m-3 img-fluid" style={{ maxWidth: '100px', filter: 'grayscale(100%)', opacity: '0.7' }} />
              <img src="/logos/35004/sponsors/35004-1.svg" alt="Voluy Fibra" className="m-3 img-fluid" style={{ maxWidth: '120px', filter: 'grayscale(100%)', opacity: '0.7' }} />
            </div>
          </div>

          {/* CTA FINAL (Design novo com texto persuasivo) */}
          <div className="text-center pb-5">
            <h4 className="font-weight-bold mb-3">Sua marca no momento de maior emoção</h4>
            <p className="text-muted mb-4">Quer ser um patrocinador oficial ou levar a Replay Pro para sua Arena? Solicite nosso Media Kit.</p>
            <div className="d-flex justify-content-center gap-3">
              <a href="/contato" className="btn btn-danger btn-lg px-5 shadow rounded-pill">
                Fale com nosso time
              </a>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(Sponsorship);